module.exports = __webpack_public_path__ + "static/media/shutterstock_2080092487.3c3c8b61.jpg";